type AnyAlloc = {
  accountId?: number; account_id?: number;
  businessCaseId?: number; business_case_id?: number;
  entityId?: number; entity_id?: number;
  key?: number; allocation_id?: number; id?: number;
  scenarioId?: (number|string)[]; scenario_id?: (number|string)[];
  targetAccountId?: number; target_account_id?: number;
  targetEntityId?: number; target_entity_id?: number;
  targetScenarioId?: (number|string)[]; target_scenario_id?: (number|string)[];
};

const toNum = (v: any) => (v == null ? undefined : Number(v));

export function buildTargetAccountSetForScenario(
  allocations: AnyAlloc[] | undefined,
  currentScenarioId: number | undefined
): Set<number> {
  const set = new Set<number>();
  const cur = toNum(currentScenarioId);
  if (!allocations || cur == null || Number.isNaN(cur)) return set;

  for (const a of allocations) {
    const tgtScenarioIds = (a.targetScenarioId ?? a.target_scenario_id ?? []).map(Number);
    const tgtAccountId = toNum(a.targetAccountId ?? a.target_account_id);
    if (tgtAccountId == null) continue;

    if (tgtScenarioIds.some(id => id === cur)) {
      set.add(tgtAccountId);
    }
  }
  return set;
}